<template>
  <div class="card">
    <div class="card-header">
      <h5>Changelog</h5>
    </div>
    <div class="card-body">
      <fieldset>
        <div class="row">
          <div class="col-12">Current Version: {{settings.version}}</div>
        </div>
      </fieldset>
      <fieldset>
        <br/>
        <div class="row  text-lg-left">          
          <div class="col-12" style="font-size:14px;">[3.0]</div>          
          <br/>
          <div class="col-12 font-weight-light" style="font-size:12px;">Προσθήκη Changelog σελίδας</div>
          <br/>
          <div class="col-12 font-weight-light" style="font-size:12px;">Διόρθωση Στατιστικών Στοιχείων στο Dashboard</div>
          <br/>
          <div class="col-12 font-weight-light" style="font-size:12px;">Διόρθωση προβλήματος στη μέτρηση howmanystudentsallow κατα την έγκριση (api,thesis,1291) </div>
          <br/>
          <div class="col-12 font-weight-light" style="font-size:12px;">Αύξηση ορίου στην αναζήτηση student 10->30 (api,user,151) </div>
          <br/>
          <div class="col-12 font-weight-light" style="font-size:12px;">Αλλαγή link για τα αρχεία στο Dashboard</div>
          <br/>
          <div class="col-12 font-weight-light" style="font-size:12px;">Βελτίωση: Αναζήτηση στην Λίστα για Φοιτητές ανα Όνομα, Επώνυμο, ΑΜ, email</div>
          <br/>
          <div class="col-12 font-weight-light" style="font-size:12px;">Υλοποίηση έκδοσης για τα δύο Μεταπτυχιακά</div>
        </div>        
      </fieldset>
    </div>
    <div class="card-header"  v-if="isAdmin3333 || isProfessor2222">
      <h5 v-html="'Οδηγίες'"></h5>
    </div>
    <div class="card-body"  v-if="isAdmin333 || isProfessor222">
      <fieldset>
        <ul class="list-group">
          <li
            class="list-group-item"
            v-html="'O επιβλέπων μπορεί να αλλάξει την λίστα με τα προαπαιτούμενα μαθήματα μόνο στις Καταστάσεις:'+Translate('@_THESIS_STATUS_AVAILABLE')+', '+Translate('@_THESIS_STATUS_TAKEN')"
          ></li>
          <li
            class="list-group-item"
            v-html="'O Admin μπορεί να αλλάξει την λίστα με τα προαπαιτούμενα μαθήματα μόνο στις Καταστάσεις:'+Translate('@_THESIS_STATUS_AVAILABLE')+', '+Translate('@_THESIS_STATUS_TAKEN')+', '+Translate('@_THESIS_STATUS_PENDINGFORAPPROVAL')+', '+Translate('@_THESIS_STATUS_APPROVEDANDWAITINGTOPRESENT')+', '+Translate('@_THESIS_STATUS_PENDINGFOREXAMANDGRADING')"
          ></li>
          <li
            class="list-group-item"
            v-html="'O επιβλέπων μπορεί να διαγράψει την Διπλωματική μόνο στις Καταστάσεις:'+Translate('@_THESIS_STATUS_AVAILABLE')"
          ></li>
          <li
            class="list-group-item"
            v-html="'O Admin μπορεί να διαγράψει την Διπλωματική μόνο στις Καταστάσεις:'+Translate('@_THESIS_STATUS_AVAILABLE')+', '+Translate('@_THESIS_STATUS_TAKEN')+', '+Translate('@_THESIS_STATUS_PENDINGFORAPPROVAL')+', '+Translate('@_THESIS_STATUS_APPROVEDANDWAITINGTOPRESENT')+', '+Translate('@_THESIS_STATUS_PENDINGFOREXAMANDGRADING')"
          ></li>
          <li class="list-group-item" v-html="'...'"></li>
        </ul>
      </fieldset>
      <fieldset>
        <h5>Καταστάσεις Διπλωματικής</h5>
        <li class="list-group-item" v-html="'1:'+Translate('@_THESIS_STATUS_AVAILABLE')"></li>
        <li class="list-group-item" v-html="'2:'+Translate('@_THESIS_STATUS_TAKEN')"></li>
        <li class="list-group-item" v-html="'3:'+Translate('@_THESIS_STATUS_PENDINGFORAPPROVAL')"></li>
        <li
          class="list-group-item"
          v-html="'4:'+Translate('@_THESIS_STATUS_APPROVEDANDWAITINGTOPRESENT')"
        ></li>
        <li
          class="list-group-item"
          v-html="'5:'+Translate('@_THESIS_STATUS_PENDINGFOREXAMANDGRADING')"
        ></li>
        <li class="list-group-item" v-html="'6:'+Translate('@_THESIS_STATUS_COMPLETED')"></li>
        <li class="list-group-item" v-html="'7:'+Translate('@_THESIS_STATUS_CANCELED')"></li>
      </fieldset>
    </div>
  </div>
</template>

<script>
import Mixin from "@/helpers/mixin";

export default {
  name: "Profile",
  mixins: [Mixin]
};
</script>

<style scoped></style>
